'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z' });

var Transform = function Transform(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Transform = (0, _pure2.default)(Transform);
Transform.muiName = 'SvgIcon';

exports.default = Transform;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Transform.js
// module id = 2957
// module chunks = 0